<!-- <div
  class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
>
  <p class="!m-0">Selected Work Packages</p>
</div>
 -->
<div class="w-[50%] mt-[7px] ml-[12px]">
  <div
  *ngIf="
   selectedWorkPackages?.length === 0
  "
  class="w-[100%] !h-10 flex justify-between items-center"
>
  <div class="flex justify-start">
    <p class="packages-name">No work package selected</p>
  </div>
</div>
  <div
    *ngFor="
      let selectedWorkPackage of selectedWorkPackages;
      let i = index
    "
    class="w-[100%] !h-10 flex justify-between items-center"
  >
    <div class="flex justify-start">
      <p class="packages-name">{{ selectedWorkPackage?.name }}</p>
    </div>
  </div>
</div>
